const mrkUrls = {
    fetchResources: {
        url: '/mrk/resource'
    },
    fetchResource: {
        url: '/mrk/resource/:id'
    },
};

export default mrkUrls;
